import Vue from 'vue';
import App from './App';
import { router } from './router';
import './assets/css/app.css';
Vue.config.productionTip = false
Vue.prototype.getRequestHeader = function () {
  var headers = {};
  var token = window.localStorage.getItem("accessToken");
 
  if (token) {
    headers['access-token'] = token;
  }
  return headers;
}
Vue.prototype.setShare = function (title, description, url, image) {
  var self = this;
  var ua = window.navigator.userAgent;
  console.log(ua);
  if (ua.match(/MicroMessenger/i) == "MicroMessenger") {
    var root = process.env.VUE_APP_API_URL;
    $.ajax({
      url: root + 'wechat/index',
      timeout: 120000,
      dataType: "json",
      type: "get",
      data: { url: url },
      headers: self.getRequestHeader(),
      success: function (reponseData, status) {
        wx.config({
          debug: false,
          appId: reponseData.appId,
          timestamp: reponseData.timestamp,
          nonceStr: reponseData.nonceStr,
          signature: reponseData.signature,
          jsApiList: [
            "chooseImage",
            "previewImage",
            "uploadImage",
            "downloadImage",
            "updateAppMessageShareData",
            "updateTimelineShareData"
          ]
        });
        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData(
            {
              title: title, // 分享标题
              desc: description, // 分享描述
              link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: image // 分享图标
            },
            function (res) {
              //这里是回调函数
            }
          );
          wx.updateTimelineShareData(
            {
              title: title, // 分享标题
              link: url, // 分享链接
              imgUrl: image, // 分享图标

            },
            function (res) {
              //这里是回调函数
            }
          );
        });

      },
      error: function () {
        self.$toast("system error");
      }
    });


  }
  if (ua.match(/QianFan/i) == "QianFan") {
    QFH5.setShareInfo(title, image, description, url, function (
      state,
      data
    ) { });
  }

}
var app = new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
